import type {
  CarDetailsForm,
  CarValueForm,
  InsuredInfoForm,
  MoreDetailsForm,
  PhoneForm,
  PlateNumberForm,
  PlateQidForm,
  PolicyDateForm,
  VinForm,
} from './FormHandlerService.types';
import { BaseService, defineApi } from '@/shared/api';

// TODO: should be in app layer
class FormHandlerService extends BaseService {
  async phone(form: PhoneForm): Promise<void> {
    return await this.post('/form/phone', form);
  }

  async plateQid(form: PlateQidForm): Promise<void> {
    return await this.post('/form/plate-qid', form);
  }

  async vin(form: VinForm): Promise<void> {
    return await this.post('/form/vin', form);
  }

  async carDetails(form: CarDetailsForm): Promise<void> {
    return await this.post('/form/car-details', form);
  }

  async moreDetails(form: MoreDetailsForm): Promise<void> {
    return await this.post('/form/more-details', form);
  }

  async carValue(form: CarValueForm): Promise<void> {
    return await this.post('/form/car-value', form);
  }

  async plateNumber(form: PlateNumberForm): Promise<void> {
    return await this.post('/form/plate-number', form);
  }

  async insuredInfo(form: InsuredInfoForm): Promise<void> {
    return await this.post('/form/insured-info', form);
  }

  async policyDate(form: PolicyDateForm): Promise<void> {
    return await this.post('/form/policy-date', form);
  }
}

export const useFormHandlerService = defineApi(FormHandlerService, { version: 'v3' });
